// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"a1d3d29f","239":"fee91d1e","732":"8de665cc"}[chunkId] + ".chunk.js";
};